













import { default as Component } from 'vue-class-component';

import SERVICES from '@/container/Services';
import IocContainer from '@/container/IocContainer';

import Language from '@/interfaces/Language';
import { Prop, Watch } from 'vue-property-decorator';
import Basic from '@/components/widgets/Basic.vue';

const langProvider = IocContainer.get<Language>(SERVICES.LANGUAGE);

interface IErrorMessage {
  key: string;
  message: string;
}

@Component({})
export default class GenericMessagesBlock extends Basic {
  @Prop({ default: '' }) public field!: string;
  @Prop({ default: false }) public isDate!: boolean;
  @Prop({ default: '' }) public message?: string;
  @Prop() public isSuccessProp?: boolean | null | undefined;

  beforeMount() {
    if (this.field === '' && !this.message) {
      throw new Error('Field is not defined and message, please provide a field to the message-block component');
    } else if (this.field !== '' && this.message) {
      throw new Error('Field is defined and message, please provide only one of them to the message-block component');
    } else if (this.field === '' && this.message && this.isSuccessProp === undefined) {
      throw new Error(
        'Message is defined, but no isSuccessProp. Please provide a isSuccessProp to the message-block component'
      );
    }
  }

  updated() {
    this.$emit('hasError');
  }

  get errors() {
    return this.store.state.errors;
  }

  get isSuccess(): boolean {
    if (this.isSuccessProp !== null && this.isSuccessProp !== undefined && typeof this.isSuccessProp === 'boolean') {
      return this.isSuccessProp;
    }
    return this.messages.length === 0;
  }

  get messages(): IErrorMessage[] {
    if (this.errors[this.field] !== undefined) {
      return this.errors[this.field];
    }
    return [];
  }

  get classObject(): { 'messages-form-success': boolean; 'messages-form-error': boolean } {
    return {
      'messages-form-success': this.isSuccess,
      'messages-form-error': !this.isSuccess
    };
  }

  protected trans(message: IErrorMessage | string): string {
    if (typeof message === 'string') {
      return message;
    }
    return langProvider.has(message.key) ? langProvider.trans(message.key) : message.message;
  }
}
